import { useTranslation } from 'react-i18next';

const testimonials = [
  {
    name: 'Aminata Diallo',
    country: 'Sénégal',
    countryEn: 'Senegal',
    university: 'Columbia University',
    image: 'https://public.readdy.ai/ai/img_res/9e6f428f9a25b8294fac048df337179d.jpg',
    textFr: 'Grâce à AfricaStudyUSA, j\'ai pu réaliser mon rêve d\'étudier à Columbia University. Leur accompagnement a été exceptionnel, de la préparation du dossier jusqu\'à mon installation à New York. Je recommande vivement leurs services à tous les étudiants africains qui souhaitent étudier aux États-Unis.',
    textEn: 'Thanks to AfricaStudyUSA, I was able to fulfill my dream of studying at Columbia University. Their support was exceptional, from application preparation to my settlement in New York. I highly recommend their services to all African students who want to study in the United States.',
    rating: 5,
  },
  {
    name: 'Kouadio Yao',
    country: 'Côte d\'Ivoire',
    countryEn: 'Ivory Coast',
    university: 'MIT',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20African%20male%20engineering%20student%20from%20Ivory%20Coast%20wearing%20smart%20casual%20clothing%2C%20confident%20expression%2C%20modern%20technology%20lab%20background%2C%20natural%20lighting%2C%20professional%20photography%20style%2C%20academic%20success%20atmosphere&width=400&height=400&seq=test-002&orientation=squarish',
    textFr: 'L\'équipe m\'a aidé à obtenir une bourse complète pour étudier l\'ingénierie au MIT. Leur expertise dans les procédures d\'admission et de visa a fait toute la différence. Aujourd\'hui, je vis mon rêve américain grâce à leur soutien professionnel et personnalisé.',
    textEn: 'The team helped me get a full scholarship to study engineering at MIT. Their expertise in admission and visa procedures made all the difference. Today, I\'m living my American dream thanks to their professional and personalized support.',
    rating: 5,
  },
  {
    name: 'Fatoumata Keita',
    country: 'Mali',
    countryEn: 'Mali',
    university: 'Stanford University',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20African%20female%20business%20student%20from%20Mali%20wearing%20professional%20attire%2C%20warm%20smile%2C%20modern%20university%20library%20background%2C%20natural%20lighting%2C%20professional%20photography%20style%2C%20confident%20and%20successful%20appearance&width=400&height=400&seq=test-003&orientation=squarish',
    textFr: 'Le processus d\'admission était complexe, mais AfricaStudyUSA a rendu tout simple et clair. Ils m\'ont accompagnée à chaque étape et m\'ont préparée pour mon entretien de visa. Je suis maintenant étudiante à Stanford et je ne pourrais pas être plus reconnaissante pour leur aide précieuse.',
    textEn: 'The admission process was complex, but AfricaStudyUSA made everything simple and clear. They supported me at every step and prepared me for my visa interview. I\'m now a student at Stanford and couldn\'t be more grateful for their valuable help.',
    rating: 5,
  },
  {
    name: 'Ange Stephane E Adou',
    country: 'Côte d\'Ivoire',
    countryEn: 'Ivory Coast',
    university: 'UC Berkeley',
    image: 'https://static.readdy.ai/image/3364e8c752bf9a3e6cc917541966dede/51c51eefcc41d19898b76e4044841ce6.jpeg',
    textFr: 'J\'avais des doutes sur mes chances d\'être accepté dans une université américaine, mais l\'équipe a cru en moi et m\'a guidé vers le succès. Leur connaissance approfondie du système éducatif américain et leur réseau de contacts ont été déterminants pour mon admission à Berkeley.',
    textEn: 'I had doubts about my chances of being accepted to an American university, but the team believed in me and guided me to success. Their deep knowledge of the American education system and their network of contacts were decisive for my admission to Berkeley.',
    rating: 5,
  },
  {
    name: 'Marie-Claire Ndiaye',
    country: 'Cameroun',
    countryEn: 'Cameroon',
    university: 'Harvard University',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20African%20female%20medical%20student%20from%20Cameroon%20wearing%20smart%20casual%20attire%2C%20confident%20smile%2C%20modern%20university%20medical%20building%20background%2C%20natural%20lighting%2C%20professional%20photography%20style%2C%20successful%20and%20inspiring%20appearance&width=400&height=400&seq=test-005&orientation=squarish',
    textFr: 'AfricaStudyUSA a transformé mon parcours académique. Non seulement ils m\'ont aidée à intégrer Harvard, mais ils continuent de me soutenir dans mon adaptation à la vie étudiante américaine. Leur service après-arrivée est tout aussi exceptionnel que leur accompagnement pré-départ.',
    textEn: 'AfricaStudyUSA transformed my academic journey. Not only did they help me get into Harvard, but they continue to support me in adapting to American student life. Their post-arrival service is just as exceptional as their pre-departure support.',
    rating: 5,
  },
  {
    name: 'Abdoulaye Sow',
    country: 'Guinée',
    countryEn: 'Guinea',
    university: 'Yale University',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20African%20male%20law%20student%20from%20Guinea%20wearing%20formal%20business%20attire%2C%20professional%20expression%2C%20classic%20university%20building%20background%2C%20natural%20lighting%2C%20professional%20photography%20style%2C%20academic%20excellence%20atmosphere&width=400&height=400&seq=test-006&orientation=squarish',
    textFr: 'Le professionnalisme et le dévouement de l\'équipe sont remarquables. Ils ont non seulement facilité mon admission à Yale, mais m\'ont également aidé à obtenir un financement substantiel. Je suis extrêmement satisfait de leur service complet et de leur engagement envers la réussite des étudiants africains.',
    textEn: 'The team\'s professionalism and dedication are remarkable. They not only facilitated my admission to Yale, but also helped me secure substantial funding. I\'m extremely satisfied with their comprehensive service and commitment to the success of African students.',
    rating: 5,
  },
];

export default function Testimonials() {
  const { t, i18n } = useTranslation('common');
  const isFrench = i18n.language === 'fr';
  
  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t('testimonials.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('testimonials.subtitle')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="flex items-center mb-6">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h3 className="text-lg font-bold text-gray-900">
                    {testimonial.name}
                  </h3>
                  <p className="text-sm text-gray-600">{isFrench ? testimonial.country : testimonial.countryEn}</p>
                </div>
              </div>
              
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg w-5 h-5 flex items-center justify-center"></i>
                ))}
              </div>
              
              <p className="text-gray-700 mb-6 leading-relaxed">
                {isFrench ? testimonial.textFr : testimonial.textEn}
              </p>
              
              <div className="pt-6 border-t border-gray-200">
                <div className="flex items-center text-teal-600 font-semibold">
                  <i className="ri-graduation-cap-line mr-2 text-xl w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-sm">{testimonial.university}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
